module.exports = __webpack_public_path__ + "static/img_4669-0d783d82254399934b4313788f8b3c91.webp";